import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom'
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as serviceWorker from './serviceWorker';
import AuthenticationContext from './Context/AuthtenticationContext'
// import ErrorBoundary from './Context/ErrorHandler/ErrorBoundary'

ReactDOM.render(
  <React.StrictMode>
    <AuthenticationContext>
        <BrowserRouter>
          {/* <ErrorBoundary> */}
            <App />
          {/* {/* </ErrorBoundary>   */}
        </BrowserRouter>
    </AuthenticationContext>
  
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
